import { AppBar, Box, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';


export default function Footer() {
    const { t } = useTranslation();

    return (
            <Paper sx={{
                //position: 'fixed',
                bottom: 0,
                width: '100%',
                zIndex: 12,
                border: 0,
                height: "100%"
            }} component="footer" square variant="outlined">
                <Box
                    sx={{
                        // flexGrow: 1,
                        justifyContent: "center",
                        display: "flex",
                        // p: 0.5,
                        backgroundColor: '#005696',
                        border: 0,
                        paddingTop: 1,
                        paddingBottom: 1
                    }}
                >
                    <Typography variant="caption" color="whitesmoke" textAlign={'center'}>
                        © {new Date().getFullYear()} {t("WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED")}. {t("All Rights Reserved")}.
                    </Typography>
                </Box>
            </Paper>
    )
}
